<template>
  <div>
    <div class="container2">
      <div class="search-line">
        <BorderTitle>日报列表</BorderTitle>

        <div class="search-form-group">
          <!-- <label class="group-label">作业区域</label>
          <el-select @change="getData" size="medium" v-model="sectionId" placeholder="请选择">
            <el-option
              v-for="item in sectionsOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </div>
        <div class="search-form-group">
          <label class="group-label">时间段</label>
          <el-date-picker
            size="medium"
            v-model="duration"
            @change="dateChange"
            type="daterange"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <el-button class="searchBtn" type="primary">查找</el-button>
      </div>
    </div>
    <div class="container2 containerList" style="background:#fff">
      <div class="container2">
        <el-table :data="dataList" style="width: 100%" size="medium">
          <el-table-column prop="order" label="序号" width="50"></el-table-column>
          <el-table-column prop="name" label="报告名称" width="290">
            <template slot-scope="scope">
              <span class="lookMore_name" @click="toInfo(scope.row)">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="workNames" label="施工作业" width=""></el-table-column>
          <el-table-column prop="sectionNames" label="标段" width=""></el-table-column>
          <el-table-column prop="minTime" label="开始作业时间" width=""></el-table-column>
          <el-table-column prop="maxTime" label="结束作业时间" width=""></el-table-column>
          <el-table-column prop="minPileNum" label="开始作业桩号" width="">
            <template slot-scope="scope">
              <span>{{workType==3||workType==4?scope.row.minPileNum:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="maxPileNum" label="结束作业桩号" width="">
            <template slot-scope="scope">
              <span>{{workType==3||workType==4?scope.row.maxPileNum:'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width>
            <template slot-scope="scope">
              <span class="lookMore" @click="toInfo(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pageCover
          class="pageBlock"
          :pageMsg="pageMsg"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
        ></el-pageCover>
      </div>
    </div>
  </div>
</template>

<script>
import BorderTitle from "../../../components/common/borderTitle";
import ElPageCover from "../../../components/overall/ElPageCover";
import {getDayReports,getWorks} from "../../../utils/api";
import { dateFormat, addOrder } from "../../../utils/commons.js";
export default {
  data() {
    return {
      pageMsg: {
        pageSize: 10,
        pageNo: 1,
        totalRecords: 0,
      },
      duration: [],
      dataList: [],
      sectionId: "",
      startDate: '',
      endDate: '',
      workType:'',
    };
  },
  props:{
    projectId: {
      type: Number,
      default: function(){
        return 0
      }
    },
  },
  watch: {
    // sectionsOptions: function (newValue) {
    //   this.sectionId = newValue[0] ? newValue[0].value : "";
    //   this.getData();
    // },
    projectId: function (newValue) {
      //console.log(newValue)
      this.getData(newValue)
    },
  },
  computed: {
    // startDate() {
    //   return (this.duration && this.duration[0]) || "";
    // },
    // endDate() {
    //   return (this.duration && this.duration[1]) || "";
    // },
    // sectionsOptions() {
    //   const workSections = this.$store.getters["quality/sections"] || [];
    //   const sectionMap = {};
    //   for (let item of workSections) {
    //     sectionMap[item.sectionId] = item.sectionName;
    //   }
    //   const list = Object.keys(sectionMap).map((key) => ({
    //     label: sectionMap[key],
    //     value: key,
    //   }));
    //   return list;
    // },
  },
  created() {},
  mounted() {
    let timer=setTimeout(()=>{
      getWorks({projectId : this.projectId}).then(res=>{
        console.log(res)
        if(res.data.content.info.list.length==0){
          this.workType==0
        }else{
          this.workType=res.data.content.info.list[0].workType
        }
      })
      clearTimeout(timer)
    },500)
    
  },
  methods: {
    dateChange(e) {
      console.log(e)
      if(e == null){
        this.startDate = ''
        this.endDate = ''
      }else{
        this.startDate = e[0]
        this.endDate = e[1]
      }
      
      this.getData(this.projectId);
    },
    toInfo(e) {
      this.$router.push({path:'/transfer/enginDaily',query:{projectId:e.id,date:e.date}});
    },
    pageSizeChange(val) {
      this.pageMsg.pageNo = val;
      this.getData(this.projectId);
    },
    currentPageChange(val) {
      this.pageMsg.pageNo = val;
      this.getData(this.projectId);
    },
    getData(newValue) {
      let parmas = {
        projectId: newValue,
        pageSize: this.pageMsg.pageSize,
        pageNo: this.pageMsg.pageNo,
      };
      if (this.startDate)
        parmas.startDate = dateFormat(this.startDate, "YYYY-MM-DD");
      if (this.endDate) parmas.endDate = dateFormat(this.endDate, "YYYY-MM-DD");
      getDayReports(parmas).then((res) => {
        // 获取作业
        this.dataList = addOrder(res.data.content.info.list);
        this.pageMsg = {
          ...this.pageMsg,
          totalRecords: res.data.content.info.totalRecords,
        };
      });
    },
  },
  components: {
    BorderTitle,
    ElPageCover,
  },
};
</script>
<style lang="scss">
.container2 {
  .el-table__header tr th{
    background-color: #EBEBEC !important;
    color: #555555 !important;
    padding: 11px 0 !important;
    font-size: 14px;
  }
  .el-range-separator{
    width: 7%;
    font-size: 12px;
    color: #555555;
  }
}
</style>
<style lang="scss" scoped="">
.container2 {
  overflow: hidden;
  // padding-bottom: 20px;
}
.pageBlock{
  margin-bottom: 3px;
}
.containerList{
  padding-bottom: 20px
}
.lookMore_name{
  cursor: pointer;
  text-decoration: underline;
}
.lookMore {
  display: inline-block;
  font-size: 14px;
  color: #e24747;
  background: rgba(255, 232, 232, 1);
  border: 1px solid rgba(226, 71, 71, 1);
  border-radius: 16px;
  padding: 4px 16px;
  margin-left: 10px;
  cursor: pointer;
}
.group-label{
  margin-right: 30px !important;
}
.searchBtn{
  margin-left: 30px !important;
}
</style>